import { createSelector } from 'reselect'

/** True only when the member has at least one LP+ renewal card and Stripe has flagged every one of them as invalid. */
const getAreAllLuxPlusRenewalCardsInvalid = createSelector(
  (state: App.State) => state.auth.account.luxPlus.member.subscription.renewalPaymentCards?.data?.cards,
  (cards): boolean => !!cards && cards.length > 0 && cards.every(card => card.isInvalid),
)

export default getAreAllLuxPlusRenewalCardsInvalid
